module.exports = __webpack_public_path__ + "static/media/ldl.9c7ccab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/assessment/ldl.png
// module id = 2778
// module chunks = 0